<template>
  <div class="home-page">
    <header-bar :active="1"></header-bar>

    <!-- 品牌视频遮罩层（沿用老站 Device.vue videomask 模式） -->
    <div class="videomask" v-if="videoState" @click="masksCloseFun"></div>
    <div class="videomasks" v-if="videoState">
      <video
        src="https://static4.coolbrainscience.cn/255dde0c27b842078f04de05912ad81b.mp4"
        controls="controls"
        autoplay
        width="100%"
      >
        当前浏览器不支持 video 直接播放。
      </video>
    </div>

    <!-- 第一屏 · 首屏 -->
    <section class="hero">
      <div class="hero-scrim"></div>
      <div class="hero-inner">
        <div class="hero-left">
          <p class="hero-eyebrow">让脑科学走出实验室</p>
          <h1 class="hero-title">基于循证的大脑表现专家</h1>
          <p class="hero-subtitle">
            {{ company.productName }}：耶鲁博士后团队研发的家用经颅电刺激设备
          </p>
          <p class="hero-tags">
            非侵入式 · EEG 实时脑电监测 + tDCS 干预一体 · 国家高新技术企业
          </p>
          <div class="hero-actions">
            <router-link to="/science" class="btn btn-ghost"
              >了解科学原理</router-link
            >
            <a
              :href="purchase.tmallFullUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-solid"
              >前往天猫官方旗舰店</a
            >
          </div>
        </div>
        <img
          class="hero-product"
          :src="require('@/assets/headband_white.png')"
          alt="般意精力舱白色头环产品图"
        />
      </div>
      <div class="hero-stats">
        <div class="hero-stat">{{ keyFacts.unitsSoldLabel }}</div>
        <div class="hero-stat">{{ keyFacts.sciPapers }} 篇学术研究积累</div>
        <div class="hero-stat">
          {{ keyFacts.certifications }} 项国内外检测认证
        </div>
      </div>
    </section>

    <!-- 第二屏 · 硬核证据墙 -->
    <section class="evidence">
      <div class="sec-title">硬核证据</div>
      <div class="sec-sub">所有数据均可查证，点击卡片展开详情</div>
      <div class="evidence-cards">
        <div
          class="evidence-card"
          :class="{ expanded: openKey === 'patent' }"
          @click="toggleCard('patent')"
        >
          <div class="evidence-kicker">知识产权</div>
          <div class="evidence-main">
            发明专利 {{ patentStats.invention }} 项 · 实用新型
            {{ patentStats.utility }} 项
          </div>
          <div class="evidence-detail">
            <div class="evidence-sub">
              专利号全部公示，可在国家知识产权局查询
            </div>
            <router-link
              to="/science"
              class="evidence-link"
              @click.native.stop
              >查看专利清单 →</router-link
            >
          </div>
          <div class="evidence-toggle">
            {{ openKey === "patent" ? "收起 −" : "展开 +" }}
          </div>
        </div>
        <div
          class="evidence-card"
          :class="{ expanded: openKey === 'cert' }"
          @click="toggleCard('cert')"
        >
          <div class="evidence-kicker">检测认证</div>
          <div class="evidence-main">
            {{ certifications.length }} 项国内外检测认证
          </div>
          <div class="evidence-detail">
            <div class="evidence-sub">每项认证附人话解读与证书编号</div>
            <img
              class="evidence-cert-img"
              src="../../assets/renzheng_logo.png"
              alt="般意精力舱八项国内外检测认证标识"
            />
            <router-link
              to="/science"
              class="evidence-link"
              @click.native.stop
              >逐项查看 →</router-link
            >
          </div>
          <div class="evidence-toggle">
            {{ openKey === "cert" ? "收起 −" : "展开 +" }}
          </div>
        </div>
        <div
          class="evidence-card"
          :class="{ expanded: openKey === 'sales' }"
          @click="toggleCard('sales')"
        >
          <div class="evidence-kicker">全球销量</div>
          <div class="evidence-main">
            {{ keyFacts.unitsSold }} 台 · 服务
            {{ keyFacts.countries }} 个国家和地区
          </div>
          <div class="evidence-detail">
            <div class="evidence-sub">
              天猫旗舰店评分 {{ keyFacts.tmallScore }}
            </div>
          </div>
          <div class="evidence-toggle">
            {{ openKey === "sales" ? "收起 −" : "展开 +" }}
          </div>
        </div>
      </div>
    </section>

    <!-- 第三屏 · 创始人 -->
    <section class="founder">
      <div class="founder-left">
        <div class="founder-kicker">为什么是般意？</div>
        <div class="founder-quote">“{{ founder.quote }}”</div>
        <div class="founder-sign">
          —— {{ founder.name }} · {{ founder.title }}
        </div>
        <div class="founder-resume">
          {{ founder.education[0] }} · {{ founder.education[1] }} ·
          {{ founder.sciPapers }} 篇学术论文 · {{ founder.followers }}
        </div>
        <router-link to="/home" class="btn btn-outline founder-btn"
          >认识创始人与团队 →</router-link
        >
      </div>
      <div class="founder-right">
        <img
          class="founder-photo"
          :src="require('@/assets/founder_photo.jpg')"
          alt="般意科技创始人姚乃琳形象照"
        />
      </div>
    </section>

    <!-- 第四屏 · 技术原理一句话版 -->
    <section class="tech">
      <div class="tech-oneliner">{{ tech.oneLiner }}</div>
      <div class="tech-mech">
        <template v-for="(step, index) in tech.mechanism">
          <div class="mech-node" :key="'node' + index">{{ step }}</div>
          <div
            v-if="index < tech.mechanism.length - 1"
            class="mech-arrow"
            :key="'arrow' + index"
          ></div>
        </template>
      </div>
      <div class="tech-row">
        <div class="tech-video-card" @click="checkVideoFun">
          <div class="play-circle play-circle-light">
            <div class="play-triangle play-triangle-light"></div>
          </div>
          <div class="tech-video-title">品牌产品视频</div>
          <div class="tech-video-sub">点击播放 · 了解般意精力舱</div>
        </div>
        <div class="tech-scene-card">
          <img
            class="tech-scene-img"
            :src="require('@/assets/wearing_scene.jpg')"
            alt="用户佩戴般意精力舱的使用场景"
          />
          <div class="tech-daily">
            每天 {{ tech.dailyUse }}，工作间隙或睡前均可使用
          </div>
        </div>
      </div>
      <router-link to="/mood" class="text-link">查看完整技术原理 →</router-link>
    </section>

    <!-- 第五屏 · 媒体报道墙 -->
    <section class="media">
      <div class="sec-title">媒体报道</div>
      <div class="media-list">
        <template v-for="(report, index) in mediaReports">
          <a
            v-if="report.url"
            :key="'media' + index"
            class="media-card"
            :href="report.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="media-outlet">{{ report.outlet }}</div>
            <div class="media-title">{{ report.title }}</div>
            <div class="media-year">{{ report.year }}</div>
          </a>
          <div v-else :key="'media' + index" class="media-card">
            <div class="media-outlet">{{ report.outlet }}</div>
            <div class="media-title">{{ report.title }}</div>
            <div class="media-year">{{ report.year }}</div>
          </div>
        </template>
      </div>
      <div class="media-more">
        更多报道请见
        <router-link to="/news" class="text-link">新闻中心 →</router-link>
      </div>
    </section>

    <!-- 第六屏 · 产品速览 -->
    <section class="products">
      <div class="sec-title">产品中心</div>
      <div class="sec-sub">总有一款适合你的大脑</div>
      <div class="product-cards">
        <div
          v-for="(item, index) in products"
          :key="'product' + index"
          class="product-card"
        >
          <div
            class="product-visual"
            :class="{ 'product-visual--contain': item.model === '经颅直流电刺激仪' }"
          >
            <img
              v-if="productImages[item.model]"
              class="product-img"
              :src="productImages[item.model]"
              :alt="item.model + '（' + item.nickname + '）产品图'"
            />
            <div v-else class="product-visual-fallback">
              <div class="product-visual-model">{{ item.model }}</div>
            </div>
          </div>
          <div class="product-body">
            <div class="product-model">{{ item.model }}</div>
            <div class="product-nickname">{{ item.nickname }}</div>
            <div class="product-row">
              <span class="product-label">定位</span>{{ item.position }}
            </div>
            <div class="product-row">
              <span class="product-label">适合人群</span>{{ item.forWhom }}
            </div>
            <div class="product-row">
              <span class="product-label">价格带</span>{{ item.priceBand }}
            </div>
            <router-link
              v-if="item.route"
              :to="item.route"
              class="text-link product-detail"
              >产品详情 →</router-link
            >
            <a
              :href="item.buyUrl || purchase.tmallFullUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-solid product-btn"
              >去{{ item.buyUrl ? "京东" : "天猫官方旗舰店" }}了解</a
            >
            <div class="product-note">
              {{
                item.buyUrl
                  ? "京东官方旗舰店在售"
                  : "请认准" + purchase.tmallPlatform + "「" + purchase.tmallStoreName + "」"
              }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 第七屏 · 安心承诺 -->
    <section class="promise">
      <div class="promise-title">安心承诺</div>
      <div class="promise-grid">
        <div
          v-for="(item, index) in purchase.afterSale"
          :key="'afterSale' + index"
          class="promise-item"
        >
          <div class="promise-dot"></div>
          <div class="promise-text">{{ item }}</div>
        </div>
      </div>
      <div class="promise-antifake">{{ purchase.antiFake }}</div>
      <router-link to="/buy" class="btn btn-outline promise-btn"
        >查看购买指引与防伪说明 →</router-link
      >
    </section>

    <footer-info></footer-info>
  </div>
</template>

<script>
import headerBar from "@/components/common/HeaderBar";
import footerInfo from "@/components/common/FooterInfo";
import {
  company,
  keyFacts,
  founder,
  products,
  purchase,
  contact,
  tech,
  patentStats,
  certifications,
  mediaReports,
} from "@/data/facts";

export default {
  name: "HomePage",
  components: {
    headerBar,
    footerInfo,
  },
  data() {
    return {
      company,
      keyFacts,
      founder,
      products,
      purchase,
      contact,
      tech,
      patentStats,
      certifications,
      mediaReports,
      // 证据墙当前展开的卡片
      openKey: "patent",
      // 品牌视频遮罩层开关
      videoState: false,
      // 产品速览卡片配图（无图的型号走品牌色渐变兜底）
      productImages: {
        "LOTUS 2": require("@/assets/product_lotus2_hero.jpg"),
        "LOTUS 2R": require("@/assets/product_lotus2r_hero.jpg"),
        Lume: require("@/assets/lume_product.png"),
        经颅直流电刺激仪: require("@/assets/headband_white.png"),
      },
    };
  },
  methods: {
    toggleCard(key) {
      this.openKey = this.openKey === key ? "" : key;
    },
    checkVideoFun() {
      this.videoState = true;
    },
    masksCloseFun() {
      this.videoState = false;
    },
  },
};
</script>

<style scoped>
.home-page {
  width: 100vw;
  overflow: hidden;
}

/* ========== 通用 ========== */
.sec-title {
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.5vw;
  color: #333333;
  text-align: center;
}

.sec-sub {
  font-family: "SourceHanSansCN-Regular";
  font-size: 1.1vw;
  color: #9b9b9b;
  text-align: center;
  margin-top: 1vw;
}

.btn {
  display: inline-block;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.05vw;
  padding: 0.85vw 2.6vw;
  border-radius: 0.3vw;
  text-decoration: none;
  cursor: pointer;
}

.btn-outline {
  color: #ffffff;
  border: 0.08vw solid rgba(255, 255, 255, 0.8);
  background: transparent;
}

.btn-outline:hover {
  background: rgba(255, 255, 255, 0.12);
}

.btn-ghost {
  color: #1b1e8a;
  border: 0.08vw solid rgba(27, 30, 138, 0.55);
  background: rgba(255, 255, 255, 0.55);
}

.btn-ghost:hover {
  color: #ffffff;
  background: #1b1e8a;
  border-color: #1b1e8a;
}

.btn-solid {
  color: #ffffff;
  background: #888ef9;
}

.btn-solid:hover {
  background: #767bef;
}

.text-link {
  font-family: "SourceHanSansCN-Medium";
  font-size: 1vw;
  color: #1b1e8a;
  text-decoration: none;
}

.text-link:hover {
  color: #888ef9;
}

/* ========== 视频遮罩层（老站 videomask 模式） ========== */
.videomask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background-color: #000;
  opacity: 0.6;
}

.videomasks {
  width: 62%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  box-shadow: 0 1vw 4vw rgba(0, 0, 0, 0.45);
}

/* ========== 第一屏 · 首屏 ========== */
.hero {
  position: relative;
  width: 100vw;
  height: 46vw;
  display: flex;
  flex-direction: column;
  background: url(~@/assets/banner_neural.jpg)
    no-repeat center 30%;
  background-size: cover;
}

/* 顶部深色渐变，保证白色导航在浅色背景上可读 */
.hero-scrim {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 11vw;
  background: linear-gradient(
    180deg,
    rgba(27, 30, 138, 0.5) 0%,
    rgba(27, 30, 138, 0) 100%
  );
  pointer-events: none;
}

.hero-inner {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6vw 13.3vw 0;
}

.hero-left {
  width: 46vw;
}

.hero-eyebrow {
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.1vw;
  color: #888ef9;
  margin: 0 0 0.8vw 0;
  letter-spacing: 0.3vw;
}

.hero-title {
  font-family: "SourceHanSansCN-Bold";
  font-size: 3.6vw;
  color: #1b1e8a;
  margin: 0;
  letter-spacing: 0.15vw;
}

.hero-subtitle {
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.3vw;
  color: #333333;
  margin-top: 1.6vw;
}

.hero-tags {
  display: inline-block;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.95vw;
  color: #1b1e8a;
  background: rgba(255, 255, 255, 0.55);
  border: 0.08vw solid rgba(27, 30, 138, 0.4);
  border-radius: 2vw;
  padding: 0.5vw 1.8vw;
  margin-top: 1.6vw;
}

.hero-actions {
  margin-top: 2.8vw;
}

.hero-actions .btn + .btn {
  margin-left: 1.6vw;
}

.hero-product {
  width: 30vw;
  margin-right: 2vw;
  filter: drop-shadow(0 1.5vw 2.5vw rgba(27, 30, 138, 0.35));
  animation: heroFloat 6s ease-in-out infinite;
}

@keyframes heroFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-0.8vw);
  }
}

.hero-stats {
  position: relative;
  display: flex;
  padding: 1.7vw 13.3vw;
  background: rgba(255, 255, 255, 0.55);
  border-top: 0.08vw solid rgba(27, 30, 138, 0.15);
}

.hero-stat {
  flex: 1;
  text-align: center;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.15vw;
  color: #1b1e8a;
}

.hero-stat + .hero-stat {
  border-left: 0.08vw solid rgba(27, 30, 138, 0.15);
}

/* ========== 第二屏 · 硬核证据墙 ========== */
.evidence {
  background: #f7f8fa;
  padding: 5.5vw 13.3vw 6.5vw;
}

.evidence-cards {
  display: flex;
  justify-content: space-between;
  margin-top: 3.5vw;
}

.evidence-card {
  position: relative;
  width: 17.3vw;
  background: #ffffff;
  border-radius: 0.5vw;
  box-shadow: 0 0.3vw 1.2vw rgba(27, 30, 138, 0.08);
  padding: 2.2vw 1.6vw 3vw;
  box-sizing: border-box;
  cursor: pointer;
  transition: box-shadow 0.25s, transform 0.25s;
}

.evidence-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 0.35vw;
  border-radius: 0.5vw 0.5vw 0 0;
  background: linear-gradient(90deg, #1b1e8a 0%, #888ef9 100%);
}

.evidence-card:hover {
  transform: translateY(-0.15vw);
  box-shadow: 0 0.5vw 1.8vw rgba(27, 30, 138, 0.16);
}

.evidence-kicker {
  display: inline-block;
  font-family: "SourceHanSansCN-Medium";
  font-size: 0.85vw;
  color: #888ef9;
  border: 0.08vw solid #888ef9;
  border-radius: 1.5vw;
  padding: 0.2vw 0.9vw;
}

.evidence-main {
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.35vw;
  color: #1b1e8a;
  line-height: 1.5;
  margin-top: 1.2vw;
  min-height: 4.1vw;
}

.evidence-detail {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.evidence-card.expanded .evidence-detail {
  max-height: 14vw;
}

.evidence-sub {
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.92vw;
  color: #666666;
  line-height: 1.7;
  margin-top: 0.8vw;
}

.evidence-cert-img {
  display: block;
  width: 100%;
  height: auto;
  margin-top: 0.9vw;
  border-radius: 0.3vw;
}

.evidence-link {
  display: inline-block;
  font-family: "SourceHanSansCN-Medium";
  font-size: 0.95vw;
  color: #1b1e8a;
  text-decoration: none;
  margin-top: 1vw;
}

.evidence-link:hover {
  color: #888ef9;
}

.evidence-toggle {
  position: absolute;
  right: 1.6vw;
  bottom: 1.2vw;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.85vw;
  color: #9b9b9b;
}

/* ========== 第三屏 · 创始人 ========== */
.founder {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #1b1e8a 0%, #0e1045 100%);
  padding: 6.5vw 13.3vw;
}

.founder-left {
  width: 42vw;
}

.founder-kicker {
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.1vw;
  color: #888ef9;
  letter-spacing: 0.2vw;
}

.founder-quote {
  font-family: "SourceHanSansCN-Bold";
  font-size: 2vw;
  color: #ffffff;
  line-height: 1.7;
  margin-top: 1.6vw;
}

.founder-sign {
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.05vw;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 1.8vw;
}

.founder-resume {
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.95vw;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.8;
  margin-top: 0.8vw;
}

.founder-btn {
  margin-top: 2.5vw;
}

.founder-right {
  width: 26vw;
}

.founder-photo {
  display: block;
  width: 26vw;
  height: 15.5vw;
  object-fit: cover;
  object-position: left center;
  border-radius: 0.8vw;
  border: 0.08vw solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 0.8vw 2.4vw rgba(0, 0, 0, 0.35);
}

.founder-video {
  width: 26vw;
  border-radius: 0.5vw;
  display: block;
  margin-top: 1.5vw;
}

.founder-video-placeholder {
  width: 26vw;
  height: 8.5vw;
  margin-top: 1.5vw;
  background: rgba(136, 142, 249, 0.12);
  border: 0.08vw solid rgba(255, 255, 255, 0.2);
  border-radius: 0.5vw;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.play-circle {
  width: 3.2vw;
  height: 3.2vw;
  border: 0.12vw solid #888ef9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.play-triangle {
  width: 0;
  height: 0;
  border-top: 0.65vw solid transparent;
  border-bottom: 0.65vw solid transparent;
  border-left: 1.05vw solid #888ef9;
  margin-left: 0.25vw;
}

.play-text {
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.95vw;
  color: rgba(255, 255, 255, 0.7);
  margin-left: 1.2vw;
}

/* ========== 第四屏 · 技术原理一句话版 ========== */
.tech {
  background: #ffffff;
  padding: 6vw 13.3vw;
  text-align: center;
}

.tech-oneliner {
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.2vw;
  color: #1b1e8a;
  line-height: 1.6;
}

.tech-mech {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3.5vw;
}

.mech-node {
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.05vw;
  color: #1b1e8a;
  background: #ffffff;
  border: 0.08vw solid #888ef9;
  border-radius: 2vw;
  padding: 0.85vw 1.8vw;
}

.mech-arrow {
  position: relative;
  width: 3vw;
  height: 0.12vw;
  background: #888ef9;
  margin: 0 0.7vw;
}

.mech-arrow::after {
  content: "";
  position: absolute;
  right: -0.05vw;
  top: -0.34vw;
  border-top: 0.4vw solid transparent;
  border-bottom: 0.4vw solid transparent;
  border-left: 0.7vw solid #888ef9;
}

.tech-row {
  display: flex;
  justify-content: space-between;
  margin-top: 3.5vw;
}

.tech-video-card {
  width: 35.6vw;
  height: 20vw;
  border-radius: 0.5vw;
  background: linear-gradient(135deg, #1b1e8a 0%, #888ef9 100%);
  box-shadow: 0 0.3vw 1.2vw rgba(27, 30, 138, 0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  transition: box-shadow 0.25s, transform 0.25s;
}

.tech-video-card:hover {
  transform: translateY(-0.15vw);
  box-shadow: 0 0.6vw 2vw rgba(27, 30, 138, 0.28);
}

.play-circle-light {
  width: 4.5vw;
  height: 4.5vw;
  border-color: rgba(255, 255, 255, 0.9);
}

.play-triangle-light {
  border-top-width: 0.9vw;
  border-bottom-width: 0.9vw;
  border-left: 1.5vw solid #ffffff;
  margin-left: 0.3vw;
}

.tech-video-title {
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.2vw;
  color: #ffffff;
  margin-top: 1.5vw;
}

.tech-video-sub {
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.9vw;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 0.6vw;
}

.tech-scene-card {
  width: 35.6vw;
  height: 20vw;
  background: #ffffff;
  border-radius: 0.5vw;
  box-shadow: 0 0.3vw 1.2vw rgba(27, 30, 138, 0.08);
  overflow: hidden;
  box-sizing: border-box;
}

.tech-scene-img {
  display: block;
  width: 100%;
  height: 15.5vw;
  object-fit: cover;
  object-position: center 40%;
}

.tech-daily {
  font-family: "SourceHanSansCN-Regular";
  font-size: 1.05vw;
  color: #333333;
  line-height: 4.5vw;
  text-align: center;
}

.tech .text-link {
  display: inline-block;
  margin-top: 3vw;
}

/* ========== 第五屏 · 媒体报道墙 ========== */
.media {
  background: #f7f8fa;
  padding: 6vw 13.3vw;
}

.media-list {
  display: flex;
  justify-content: space-between;
  margin-top: 3.5vw;
}

.media-card {
  position: relative;
  display: block;
  width: 23vw;
  background: #ffffff;
  border-radius: 0.5vw;
  box-shadow: 0 0.3vw 1.2vw rgba(27, 30, 138, 0.06);
  padding: 2.1vw 1.8vw 1.8vw;
  box-sizing: border-box;
  text-decoration: none;
  transition: box-shadow 0.25s, transform 0.25s;
}

.media-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 0.35vw;
  border-radius: 0.5vw 0.5vw 0 0;
  background: linear-gradient(90deg, #1b1e8a 0%, #888ef9 100%);
}

.media-card:hover {
  transform: translateY(-0.15vw);
  box-shadow: 0 0.5vw 1.8vw rgba(27, 30, 138, 0.14);
}

.media-outlet {
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.15vw;
  color: #1b1e8a;
}

.media-title {
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.95vw;
  color: #333333;
  line-height: 1.7;
  margin-top: 0.9vw;
  min-height: 3.2vw;
}

.media-year {
  font-family: "SourceHanSansCN-Light";
  font-size: 0.85vw;
  color: #9b9b9b;
  margin-top: 1vw;
}

.media-more {
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.95vw;
  color: #9b9b9b;
  text-align: center;
  margin-top: 3vw;
}

/* ========== 第六屏 · 产品速览 ========== */
.products {
  background: #ffffff;
  padding: 6vw 13.3vw;
}

.product-cards {
  display: flex;
  justify-content: space-between;
  margin-top: 3.5vw;
}

.product-card {
  width: 23vw;
  background: #ffffff;
  border-radius: 0.5vw;
  box-shadow: 0 0.3vw 1.2vw rgba(27, 30, 138, 0.08);
  overflow: hidden;
  box-sizing: border-box;
  transition: box-shadow 0.25s, transform 0.25s;
  display: flex;
  flex-direction: column;
}

.product-card:hover {
  transform: translateY(-0.15vw);
  box-shadow: 0 0.5vw 1.8vw rgba(27, 30, 138, 0.16);
}

.product-visual {
  width: 100%;
  height: 13.5vw;
}

.product-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-visual-fallback {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1b1e8a 0%, #888ef9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-visual--contain {
  background: linear-gradient(135deg, #f4f6ff 0%, #e3e9f8 100%);
}

.product-visual--contain .product-img {
  object-fit: contain;
  padding: 1.2vw;
  box-sizing: border-box;
}

.product-visual-model {
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.6vw;
  color: #ffffff;
  letter-spacing: 0.2vw;
}

.product-body {
  padding: 1.7vw 1.8vw 1.6vw;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.product-model {
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.6vw;
  color: #1b1e8a;
}

.product-nickname {
  font-family: "SourceHanSansCN-Medium";
  font-size: 1vw;
  color: #888ef9;
  margin-top: 0.4vw;
}

.product-row {
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.92vw;
  color: #333333;
  line-height: 1.7;
  margin-top: 1vw;
}

.product-label {
  display: inline-block;
  font-family: "SourceHanSansCN-Medium";
  color: #9b9b9b;
  margin-right: 0.6vw;
}

.product-detail {
  display: inline-block;
  margin-top: 1.4vw;
  margin-bottom: 1.4vw;
}

.product-btn {
  display: block;
  text-align: center;
  margin-top: auto;
  padding-top: 0.9vw;
  padding-bottom: 0.9vw;
  white-space: nowrap;
}

.product-note {
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.8vw;
  color: #9b9b9b;
  text-align: center;
  margin-top: 1.2vw;
}

/* ========== 第七屏 · 安心承诺 ========== */
.promise {
  position: relative;
  background: url(~@/assets/wearing_scene.jpg)
    no-repeat center 30%;
  background-size: cover;
  padding: 6vw 13.3vw;
  text-align: center;
}

.promise::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(27, 30, 138, 0.93) 0%,
    rgba(14, 16, 69, 0.88) 100%
  );
}

.promise > * {
  position: relative;
  z-index: 1;
}

.promise-title {
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.5vw;
  color: #ffffff;
}

.promise-grid {
  display: flex;
  justify-content: space-between;
  margin-top: 3.5vw;
}

.promise-item {
  width: 17.3vw;
  background: rgba(255, 255, 255, 0.08);
  border: 0.08vw solid rgba(255, 255, 255, 0.25);
  border-radius: 0.5vw;
  padding: 2vw 1vw;
  box-sizing: border-box;
}

.promise-dot {
  width: 0.8vw;
  height: 0.8vw;
  border-radius: 50%;
  background: #888ef9;
  margin: 0 auto;
}

.promise-text {
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.1vw;
  color: #ffffff;
  margin-top: 1.2vw;
}

.promise-antifake {
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.95vw;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.8;
  margin-top: 3vw;
}

.promise-btn {
  margin-top: 2.2vw;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/HomePage.vue